import React, { useState, useCallback } from 'react';
import SignupCollectionAction from '../SignupCollectionAction';
import ExternalLink from '../ExternalLink';

const Step4Collection = () => {
    const [isSending, setIsSending] = useState(false);
    const [canContinue, setCanContinue] = useState(false);

    const getSending = useCallback((value) => {
        setIsSending(value);
    }, []);

    const hasError = useCallback((error) => {
        setCanContinue(Boolean(!error));
    }, []);

    return (
        <>
            <div className="step-container">
                <div className="step-circle">
                    <span>4</span>
                </div>
                <ExternalLink getSending={getSending} hasError={hasError} />
            </div>
            <SignupCollectionAction step={4} optional={true} isValid={canContinue} isSending={isSending} />
        </>
    );
};

export default Step4Collection;
